export enum FeedbackType {
  orderLike = 5,
  orderDislike = 10,
  postamat = 0,
}
